import React, { useContext } from "react";
import MUIDialogTitle from "@mui/material/DialogTitle";
import { getClassName } from "@sscs/utils";
import { CloseIcon } from "../../icons";
import IconButton from "../IconButton/IconButton";
import LongTextLabel from "../LongTextLabel/LongTextLabel";
import styles from "./dialog.module.scss";
import { DialogCloseContext } from "./DialogFrame";
/** The dialog's `h2`. `id` lets a Frame point its `aria-labelledby` at this heading. */
const Title = ({ id, className, children, }) => (React.createElement("h2", { id: id, className: getClassName(styles.title, className) }, children));
/** Fainter second line under the Title — a purl, a package name, a hint. */
const Subtitle = ({ className, children }) => typeof children === "string" ? (React.createElement(LongTextLabel, { label: children, className: getClassName(styles.subtitle, className) })) : (React.createElement("div", { className: getClassName(styles.subtitle, className) }, children));
/** The dialog's top band: Title (+ optional Subtitle) left, close button right. The close button comes from the Frame's `onClose` context, never a child. */
const Header = ({ className, children }) => {
    const onClose = useContext(DialogCloseContext);
    return (React.createElement(MUIDialogTitle, { component: "div", className: getClassName(styles.header, className) },
        React.createElement("div", { className: styles.heading }, children),
        onClose && (React.createElement(IconButton, { "aria-label": "Close", onClick: onClose },
            React.createElement(CloseIcon, null)))));
};
Header.Title = Title;
Header.Subtitle = Subtitle;
export { Title, Subtitle };
export default Header;
//# sourceMappingURL=DialogHeader.js.map